/**
 * 一次定时器
 *
 * @param {Function} cb 回调
 * @param {Number} timeout 执行时间(ms)
 */
export function sleep(cb, timeout) {
  let timer = setTimeout(() => {
    clearTimeout(timer)
    cb && cb()
  }, timeout)
  return timer
}

/**
 * 多次定时器
 *
 * @param {Function} cb 回调 cb(count, stop)
 * @param {Number} interval 执行间隔(ms)
 * @param {Number} [count=-1] 执行次数（负数代表无限次）
 * @example
 *  loop((count, stop) => {
 *    // count: 当前执行次数
 *    // stop: 立即停止定时器钩子
 *    console.log(count)
 *    if (count == 30) stop()
 *  }, 200, 60)
 * @tip 即使调用后立即停止定时器，仍然会执行一次！
 */
export function loop(cb, interval, count=-1) {
  let innerCount = 0
  let timer
  
  timer = setInterval(() => {

    cb && cb(++innerCount, () => clearInterval(timer))

    // count为有效次数并且执达到执行次数，清空定时器
    if (count >= 0 && innerCount >= count) {
      clearInterval(timer)
    }

  }, interval);

  // 立即执行一次回调
  cb && cb(innerCount, () => clearInterval(timer))

  return timer
}

/**
 * 倒数定时器
 *
 * @param {Function} current 每次执行回调 current(count, stop)
 * @param {Function} lastone 最后一次执行回调 lastone(count, stop)
 * @param {Number} interval 执行间隔(ms)
 * @param {Number} [count=1] 执行次数（最少1次）
 */
export function countdown({ current, lastone, interval, count=1 }) {
  let innerCount = count
  let timer

  timer = loop((red, stop) => {

    // 如果有传lastone，则current最后一次不执行
    if (lastone) {
      innerCount <= 0 ? 
        lastone(innerCount, stop) : ( current && current(innerCount, stop) )
    }
    else {
      current && current(innerCount, stop)
    }

    innerCount --

  }, interval, count)

  return timer
}

/**
 * 倒计时定时器
 *
 * @param {Function} current 每次执行回调 current(count, stop)
 * @param {Function} lastone 最后一次执行回调 lastone(count, stop)
 * @param {Number} [count=1] 执行次数（最少1次）
 */
export function countdownSeconds({ current, lastone, count }) {
  return countdown({
    current,
    lastone,
    count,
    interval: 1000
  })
}